import React, { useMemo } from "react";
import { format, isSameDay } from "date-fns";
import { SchedulerViewComponentProps } from "../../types/views";

const ListView: React.FC<SchedulerViewComponentProps> = ({
  events,
  currentDate,
  onEventClick,
  schedulerTheme,
}) => {
  const visibleEvents = useMemo(
    () =>
      [...events]
        .filter((event) => isSameDay(new Date(event.timeRange.start), currentDate))
        .sort(
          (left, right) =>
            new Date(left.timeRange.start).getTime() -
            new Date(right.timeRange.start).getTime()
        ),
    [currentDate, events]
  );

  return (
    <div className="h-full overflow-auto bg-white p-4">
      <div className="mb-4">
        <h3 className="text-lg font-semibold text-gray-900">
          Schedule for {format(currentDate, "MMMM d, yyyy")}
        </h3>
        <p className="text-sm text-gray-500">
          {visibleEvents.length} scheduled event{visibleEvents.length === 1 ? "" : "s"}
        </p>
      </div>

      <div className="space-y-3">
        {visibleEvents.length === 0 ? (
          <div className="rounded-lg border border-dashed border-gray-300 p-6 text-sm text-gray-500">
            No events scheduled for this day.
          </div>
        ) : (
          visibleEvents.map((event) => (
            <button
              key={event.id}
              type="button"
              className="w-full rounded-lg border border-gray-200 p-4 text-left shadow-sm hover:border-blue-300"
              style={{
                backgroundColor: schedulerTheme?.getEventColor?.(event) || "#eff6ff",
                color: schedulerTheme?.eventTextColor || "#111827",
              }}
              onClick={(buttonEvent) =>
                onEventClick?.(
                  event,
                  buttonEvent.currentTarget as unknown as HTMLElement,
                  undefined
                )
              }
            >
              <div className="text-sm font-semibold">{event.title}</div>
              <div className="mt-1 text-xs opacity-80">
                {format(new Date(event.timeRange.start), "h:mm a")} -{" "}
                {format(new Date(event.timeRange.end), "h:mm a")}
              </div>
            </button>
          ))
        )}
      </div>
    </div>
  );
};

export default ListView;
